<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/busca" name="Busca" icon="ti-search"/>
        <sidebar-link to="/novidades" name="Novidades" icon="ti-announcement"/>
        <sidebar-link to="/recomendados" name="Recomendados" icon="ti-star"/>
        <sidebar-link to="/addBook" name="Adicionar Livro" icon="ti-plus" v-if='isEditor'/>
        <sidebar-link to="/editoras" name="Editoras" icon="ti-pencil-alt" v-if='isEditor'/>
        <sidebar-link to="/autores" name="Autores" icon="ti-pencil-alt" v-if='isEditor'/>
        <sidebar-link to="/categorias" name="Categorias" icon="ti-pencil-alt" v-if='isEditor'/>
        <sidebar-link to="/colecoes" name="Coleções" icon="ti-pencil-alt" v-if='isEditor'/>
        <sidebar-link to="/tags" name="Tags" icon="ti-pencil-alt" v-if='isEditor'/>
        <sidebar-link to="/emprestimos" name="Empréstimos" icon="ti-share" v-if='isEditor'/>
        <sidebar-link to="/reservas" name="Reservas" icon="ti-time" v-if='isEditor'/>
        <sidebar-link to="/configuracoes" name="Configurações" icon="ti-settings" v-if='isEditor'/>
        <sidebar-link to="/usuarios" name="Usuários" icon="ti-user" v-if='isAdmin'/>
        <sidebar-link to="/estatisticas" name="Estatísticas" icon="ti-bar-chart" v-if='isEditor'/>
      </template>
      <mobile-menu>
        <li class="nav-item" v-if="!user">
            <router-link class='nav-link' to='login'>
              <i class="ti-user"></i>
              <p>
                Login
              </p>
            </router-link>
          </li>
          <drop-down v-if="user"
                class="nav-item"
                     :title="user.name"
                     title-classes="nav-link"
                     icon="ti-user">
            <router-link class='dropdown-item' to='editProfile'>Editar Perfil</router-link>
            <router-link class='dropdown-item' to='passwordChange'>Trocar Senha</router-link>
            <a class="dropdown-item" href="#" @click.stop.prevent='logout()'>Logout</a>
          </drop-down>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },

  computed: {
    ...mapState(['user']),
    ...mapGetters(['isEditor','isAdmin'])
  },

  data () {
    return {
      logged: false
    }
  },

  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    logout () {
      this.$stote.dispatch('logout')
      this.$router.push('busca')
    }
  }
}
</script>
